<div class="marker-wrapper" [ngClass]="{ 'is-uncertain': componentData().isUncertain,'is-for-sale': componentData()?.isForSale}">
    <div class="icon" [class]="'property-' + componentData().estateType"></div>
       @if (componentData().isWithdrawn || componentData().isOutdated) {
                <div class="withdrawn">T</div>
                }
    <div class="price-tag">
        @if(price()){
        <b>{{ price() / 1000000 | number : "1.1-1" | dash }}</b> mill } @if(validArea()) { <b>{{ validArea() }}</b
        >m² }
    </div>
</div>
